// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const SchoolsPure = createIcon(`
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
	 viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
<style type="text/css">
	.schools0{fill:none;stroke:#0A055F;stroke-width:2.6562;stroke-miterlimit:10;}
	.schools1{fill:none;stroke:#FF4114;stroke-width:2.6562;stroke-miterlimit:10;}
</style>
<g>
	<path class="schools0" d="M117.5,60c0,31.7-25.8,57.5-57.5,57.5S2.5,91.7,2.5,60S28.3,2.5,60,2.5S117.5,28.3,117.5,60z"/>
	<polyline class="schools1" points="33.7,40.2 25.5,40.2 25.5,86.9 95.8,86.9 95.8,40.2 87.8,40.2 	"/>
	<path class="schools1" d="M60.8,39.9c0-4,3.2-7.6,7.6-7.6H86v44.5H68.7c-4.1,0-8,1.4-8,7V39.9z"/>
	<path class="schools1" d="M60.8,39.9c0-4,3.2-7.6,7.6-7.6H86v44.5H68.7c-4.1,0-8,1.4-8,7V39.9z"/>
	<path class="schools1" d="M60.8,39.9c0-4-3.2-7.6-7.6-7.6H35.5v44.5h17.3c4.1,0,8,1.4,8,7V39.9z"/>
	<path class="schools1" d="M60.8,39.9c0-4-3.2-7.6-7.6-7.6H35.5v44.5h17.3c4.1,0,8,1.4,8,7V39.9z"/>
	<line class="schools1" x1="60.8" y1="83.8" x2="60.8" y2="86.9"/>
</g>
</svg>
`);

export const SchoolsIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <SchoolsPure className={props.iconClassName} />
);

SchoolsIcon.displayName = 'SchoolsIcon';
